import { useOutletContext } from "react-router-dom";

import OrganizationSettingsStudioView from "../../views/OrganizationSettingsView/OrganizationSettingsStudioView";

export default function OrganizationSettingsStudio() {
	const { organization } = useOutletContext();

	return <OrganizationSettingsStudioView organization={organization} />;
}
